import {
  box_styles_default
} from "./chunk.7F2ADSAG.js";
import {
  createBreakpointClassInfo
} from "./chunk.JI3RRLCG.js";
import {
  DisplayPropertyConverter,
  SpacePropertyConverter,
  displayTypes,
  spaceSizes
} from "./chunk.5JHTBFE5.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  n
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass,
  __spreadValues
} from "./chunk.K2NRSETB.js";

// src/components/box/box.ts
var FadvBox = class extends s {
  constructor() {
    super(...arguments);
    this.p = null;
    this.pt = null;
    this.pr = null;
    this.pb = null;
    this.pl = null;
    this.ph = null;
    this.pv = null;
    this.m = null;
    this.mt = null;
    this.mr = null;
    this.mb = null;
    this.ml = null;
    this.mh = null;
    this.mv = null;
    this.display = "block";
    this.invert = false;
  }
  render() {
    return $`<div class=${o(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({
      box: true,
      "box--invert": this.invert
    }, createBreakpointClassInfo(this, "p", spaceSizes)), createBreakpointClassInfo(this, "pt", spaceSizes)), createBreakpointClassInfo(this, "pr", spaceSizes)), createBreakpointClassInfo(this, "pb", spaceSizes)), createBreakpointClassInfo(this, "pl", spaceSizes)), createBreakpointClassInfo(this, "ph", spaceSizes)), createBreakpointClassInfo(this, "pv", spaceSizes)), createBreakpointClassInfo(this, "m", spaceSizes)), createBreakpointClassInfo(this, "mt", spaceSizes)), createBreakpointClassInfo(this, "mr", spaceSizes)), createBreakpointClassInfo(this, "mb", spaceSizes)), createBreakpointClassInfo(this, "ml", spaceSizes)), createBreakpointClassInfo(this, "mh", spaceSizes)), createBreakpointClassInfo(this, "mv", spaceSizes)), createBreakpointClassInfo(this, "display", displayTypes)))} ><slot></slot></div>`;
  }
};
FadvBox.styles = box_styles_default;
__decorateClass([
  e({ converter: SpacePropertyConverter })
], FadvBox.prototype, "p", 2);
__decorateClass([
  e({ converter: SpacePropertyConverter })
], FadvBox.prototype, "pt", 2);
__decorateClass([
  e({ converter: SpacePropertyConverter })
], FadvBox.prototype, "pr", 2);
__decorateClass([
  e({ converter: SpacePropertyConverter })
], FadvBox.prototype, "pb", 2);
__decorateClass([
  e({ converter: SpacePropertyConverter })
], FadvBox.prototype, "pl", 2);
__decorateClass([
  e({ converter: SpacePropertyConverter })
], FadvBox.prototype, "ph", 2);
__decorateClass([
  e({ converter: SpacePropertyConverter })
], FadvBox.prototype, "pv", 2);
__decorateClass([
  e({ converter: SpacePropertyConverter })
], FadvBox.prototype, "m", 2);
__decorateClass([
  e({ converter: SpacePropertyConverter })
], FadvBox.prototype, "mt", 2);
__decorateClass([
  e({ converter: SpacePropertyConverter })
], FadvBox.prototype, "mr", 2);
__decorateClass([
  e({ converter: SpacePropertyConverter })
], FadvBox.prototype, "mb", 2);
__decorateClass([
  e({ converter: SpacePropertyConverter })
], FadvBox.prototype, "ml", 2);
__decorateClass([
  e({ converter: SpacePropertyConverter })
], FadvBox.prototype, "mh", 2);
__decorateClass([
  e({ converter: SpacePropertyConverter })
], FadvBox.prototype, "mv", 2);
__decorateClass([
  e({ converter: DisplayPropertyConverter })
], FadvBox.prototype, "display", 2);
__decorateClass([
  e({ reflect: true, type: Boolean })
], FadvBox.prototype, "invert", 2);
FadvBox = __decorateClass([
  n("fadv-box")
], FadvBox);

export {
  FadvBox
};
